module.exports = __webpack_public_path__ + "media/images/whatsapp-71b89ca82095c1bcfc4f985aae022084.png";